module.exports = __webpack_public_path__ + "6a676ef41bb1b2587289c9c5f4ea8963.MP3";